export const VoiceSearchRecognitionStatus = {
  IDLE: 'idle',
  LISTENING: 'listening',
  PROCESSING: 'processing',
  ERROR: 'error',
} as const
export type VoiceSearchRecognitionStatus =
  (typeof VoiceSearchRecognitionStatus)[keyof typeof VoiceSearchRecognitionStatus]

export const SpeechRecognitionErrorType = {
  NO_SPEECH: 'no-speech',
  NOT_ALLOWED: 'not-allowed',
  SERVICE_NOT_ALLOWED: 'service-not-allowed',
  ABORTED: 'aborted',
} as const
export type SpeechRecognitionErrorType =
  (typeof SpeechRecognitionErrorType)[keyof typeof SpeechRecognitionErrorType]

export interface SpeechRecognitionError {
  error: SpeechRecognitionErrorType
  message: string
}

export interface SpeechRecognitionAlternative {
  transcript: string
  confidence: number
}

export interface SpeechRecognitionResult {
  [index: number]: SpeechRecognitionAlternative
  length: number
  item(index: number): SpeechRecognitionAlternative
  isFinal: boolean
}

export interface SpeechRecognitionResultList {
  [index: number]: SpeechRecognitionResult
  length: number
  item(index: number): SpeechRecognitionResult
}

export interface SpeechRecognitionResultEvent {
  resultIndex: number
  results: SpeechRecognitionResultList
}

export interface SpeechRecognition {
  continuous: boolean
  interimResults: boolean
  lang: string | undefined
  maxAlternatives: number
  start(): void
  stop(): void
  abort(): void
  onstart: ((this: SpeechRecognition, ev: Event) => void) | null
  onresult:
    | ((this: SpeechRecognition, ev: SpeechRecognitionResultEvent) => void)
    | null
  onerror:
    | ((this: SpeechRecognition, ev: SpeechRecognitionError) => void)
    | null
  onend: ((this: SpeechRecognition, ev: Event) => void) | null
}
